// removed by extract-text-webpack-plugin
module.exports = {"root":"root___1kZTe"};


//////////////////
// WEBPACK FOOTER
// ./src/components_business/Address/Index.less
// module id = E8hL
// module chunks = 0 9 12 13